import React, { useMemo } from 'react';

import Slider from 'react-slick';
import { Skeleton, Tab } from '@mui/material';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import {
  isSameDay,
} from 'date-fns';
import { uniqueId } from 'lodash';
import moment from 'moment';
import 'moment/locale/vi';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import FlexColCenter from '@/components/FlexColCenter';
import { TDateObjectArr } from './type';
import { style } from '@/styles/globals';
import { vi } from 'date-fns/locale';

const StyledTab = styled(Tab)(({ isselected }: { isselected?: string }) => ({
  textTransform: 'none',
  padding: '0.2em',
  marginLeft: '0.2em',
  marginRight: '0.2em',
  marginTop: '0.5em',
  marginBottom: '0.5em',
  minWidth: '56px ',
  minHeight: 0,
  borderRadius: '0.5em',
  margin: '0.5em',
  height: '44px',
  opacity: 1,
  ...(isselected !== 'true' ? {} : {
    background: style.color.product4,
    boxSizing: 'border-box',
  }),
}));

const StyledSlider = styled(Slider)`
  '& .slick-slide' : {
    margin-right:10px
  } 

`;

const Wrapper = styled('div')({
  '.slick-slider': {
    display: 'flex !important',
    border: '1px solid white',
    overflow: 'hidden',
    marginTop: '16px',
  },
});

const StyleArrow = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: '#D0D2D3',
  minWidth: '26px',
});

const SampleNextArrow = (props: any) => {
  const { onClick } = props;
  return (
    <StyleArrow
      key={uniqueId()}
      onClick={onClick}
      style={{
        borderTopRightRadius: '4px',
        background: 'white',
      }}
    >
      <ArrowForwardIosOutlinedIcon
        htmlColor={style.color.black4}
        fontSize="small"
      />
    </StyleArrow>
  );
};

const SamplePrevArrow = (props: any) => {
  const { onClick } = props;
  return (
    <StyleArrow
      key={uniqueId()}
      style={{
        borderTopLeftRadius: '4px',
        background: 'white',
      }}
      onClick={onClick}
    >
      <ArrowBackIosOutlinedIcon
        htmlColor={style.color.black4}
        fontSize="small"
      />
    </StyleArrow>
  );
};

const HorizontalMinFareBar = ({
  days,
  onSelectDate,
  selectedDate = '',
  isFetching,
  errorStatistics,
  isDesktop,
}: any) => {
  const isLoading = isFetching;

  const settings = {
    dots: false,
    infinite: false,
    slidesToShow: isDesktop ? 8 : 5,
    slidesToScroll: isDesktop ? 8 : 5,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  const tabArr = useMemo(() => (days as TDateObjectArr).slice(0, 30).map((item) => {
    const isSelected = isSameDay(new Date(selectedDate), item.date);
    const color = isSelected ? style.color.product3 : style.color.black2;
    return (
      <StyledTab
        isselected={`${isSelected}`}
        key={uniqueId()}
        label={(
          <FlexColCenter
            onClick={() => {
              onSelectDate(item.date);
            }}
            sx={{ minWidth: 45 }}
          >
            <Typography
              variant="caption"
              sx={{
                fontWeight: '500',
                color,
                whiteSpace: 'nowrap',
              }}
            >
              {moment(item.date).format('DD/MM')}
            </Typography>
            <Typography
              variant="caption"
              style={{ minWidth: '75%' }}
              sx={{
                color,
              }}
            >
              {!item.minFare && (isLoading || errorStatistics) && <Skeleton />}
              {!item.minFare && !isLoading && !errorStatistics && '-'}
              {item.minFare && (item.minFare || <Skeleton />)}
            </Typography>
          </FlexColCenter>
            )}
      />
    );
  }), [days, selectedDate]);

  return (
    <Wrapper>
      <link
        rel="stylesheet"
        type="text/css"
        charSet="UTF-8"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
      />
      <StyledSlider {...settings}>
        {/* <Stack
          direction="row"
          // spacing="10px"
        > */}
        {tabArr}

        {/* </Stack> */}
      </StyledSlider>
    </Wrapper>
  );
};

export default HorizontalMinFareBar;
